import { Controller } from "@hotwired/stimulus";

/**
 * Supplier Quote Form Controller
 *
 * This controller manages the calculation of totals for an entire supplier quote form,
 * including subtotal and total amount.
 */
export default class extends Controller {
  static targets = ["itemsContainer", "subtotal", "total", "totalInput"];

  connect() {
    this.recalculateTotal();
  }

  /**
   * Recalculate all totals when any item changes
   */
  recalculateTotal() {
    // Calculate subtotal (sum of all item totals)
    const items = this.element.querySelectorAll(".supplier-quote-item");
    let subtotal = 0;

    items.forEach((item) => {
      const quantityInput = item.querySelector(
        "[data-supplier-quote-item-target='quantity']"
      );
      const unitPriceInput = item.querySelector(
        "[data-supplier-quote-item-target='unitPrice']"
      );

      if (quantityInput && unitPriceInput) {
        const quantity = parseFloat(quantityInput.value) || 0;
        const unitPrice = parseFloat(unitPriceInput.value) || 0;
        subtotal += quantity * unitPrice;
      }
    });

    // Update the subtotal display
    if (this.hasSubtotalTarget) {
      this.subtotalTarget.textContent = this.formatCurrency(subtotal);
    }

    // Calculate and update the total amount
    const totalAmount = subtotal;

    if (this.hasTotalTarget) {
      this.totalTarget.textContent = this.formatCurrency(totalAmount);
    }

    // Update the hidden total input field if it exists
    if (this.hasTotalInputTarget) {
      this.totalInputTarget.value = totalAmount.toFixed(2);
    }
  }

  /**
   * Format a number as currency (F CFA)
   * @param {Number} amount - The amount to format
   * @returns {String} Formatted currency string
   */
  formatCurrency(amount) {
    // Format the number with thousand separators and 0 decimals
    const formattedAmount = new Intl.NumberFormat("fr-FR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);

    return `${formattedAmount} F CFA`;
  }
}
